import { ENDPOINTS, get } from '~/api'

class FeatureGatingManager {
  private memo: Map<string, boolean>

  constructor() {
    this.memo = new Map<string, boolean>()
  }

  public isEnabled(featureKey: string, flipperId?: string): Promise<boolean> {
    const key = FeatureGatingManager.buildFeatureURL(featureKey, flipperId)
    return new Promise(resolve => {
      if (this.memo.has(key)) {
        resolve(this.memo.get(key))
      } else {
        get(ENDPOINTS.API_XFERS_CHECK_FEATURE, key)
          .then(resp => {
            this.memo.set(key, resp.data[featureKey])
            resolve(resp.data[featureKey])
          })
          .catch(err => {
            console.error(err) // eslint-disable-line
            resolve(false)
          })
      }
    })
  }

  public isSomeEnabled(featureArray: { featureKey: string; flipperId?: string }[]) {
    return Promise.all(
      featureArray.map(feature => this.isEnabled(feature.featureKey, feature.flipperId))
    ).then(respArray => {
      return respArray.some(resp => resp === true)
    })
  }

  public isAllEnabled(featureArray: { featureKey: string; flipperId?: string }[]) {
    return Promise.all(
      featureArray.map(feature => this.isEnabled(feature.featureKey, feature.flipperId))
    ).then(respArray => {
      return respArray.every(resp => resp === true)
    })
  }

  static buildFeatureURL(featureKey: string, flipperId?: string): string {
    let params = '?'
    params = params + 'features=' + JSON.stringify([featureKey])
    if (flipperId) {
      params = params + '&flipper_id=' + encodeURIComponent(flipperId)
    }
    return params
  }
}

export default new FeatureGatingManager()
